import axios from "axios";

export const fetchCreateCompany = async (data: any) => {
  return await axios.post("/api/company", data);
};
